module.exports = __webpack_public_path__ + "img/MpeV3B-1.9755efcd.jpg";